<script setup>
  import { storeToRefs } from 'pinia'
  import { useFilterStore } from '@/stores/filter'

  import DataGridFilterSelect from '@/components/Landingpage/DataGridFilterSelect.vue'
  import DataGridDatePicker from '@/components/Landingpage/DataGridDatePicker.vue'

  const store = useFilterStore()
  const { activeFilters } = storeToRefs(store)

  const props = defineProps({
    filters: Object
  })

  const updateFilter = (value, target) => {
    store.setActiveFilters(value, target)
  }

</script>

<template>
  <div
    class="data-grid-filter-items flex flex-col xl:flex-row ~gap-2/4 items-center mb-6"
  >
    <div
      class="filter-item-wrapper w-full"
      v-for="filter in filters"
      :key="filter.id"
    >
      <DataGridFilterSelect
        v-if="filter.target !== 'startDate'"
        :filter="filter"
        :active-filters="activeFilters"
        @updateFilter="updateFilter"
      />
      <DataGridDatePicker
        v-else
        :filter="filter"
        :active-filters="activeFilters"
        @updateFilter="updateFilter"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>

</style>
